var vskoModal = angular.module('vskoModal', ['ui.bootstrap']);

vskoModal.directive('vskoModal', [function() {
  return {
    restrict: 'E',
    template: require('./vsko-modal.html'),
    transclude: {
      headerSlot: '?vskoModalHeader',
      bodySlot: 'vskoModalBody',
      footerSlot: 'vskoModalFooter'
    },
    link: function(scope, element, attrs) {
      'use strict';
    }
  }
}]);

vskoModal.directive('vskoModalHeader', [function() {
  return {
    restrict: 'E',
    template: require('./vsko-modal-header.html'),
    transclude: true,
    scope: {
      hideClose: '@',
      cancel: '=?'
    }
  }
}]);

vskoModal.directive('vskoModalBody', [function() {
  return {
    restrict: 'E',
    template: require('./vsko-modal-body.html'),
    transclude: true
  }
}]);

vskoModal.directive('vskoModalFooter', [function() {
  return {
    restrict: 'E',
    template: require('./vsko-modal-footer.html'),
    transclude: true,
    scope: {
      hideCancel: '@',
      cancel: '=?'
    }
  }
}]);
